import { Loader } from '../../../../components/loader/loader';
import { Page } from '../../../../components/page/page';
import { DeleteModal } from '../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../features/has-access/has-access';
import { RestoreModal } from '../../../../features/restore-modal/restore-modal';
import { FormsCards } from './forms-cards/forms-cards';
import { FormsControls } from './forms-controls/forms-controls';
import s from './forms-list.module.css';
import { FormsTable } from './forms-table/forms-table';
import { useFormsList } from './use-forms-list';

export const FormsList = () => {
  const { isLoadingFetch, t, restoreForm, deleteForm, viewStyle } = useFormsList();

  return (
    <Page className={s.page}>
      {isLoadingFetch && <Loader />}
      <h2 className={s.title}>
        {t('Формы')}
        <FormsControls />
      </h2>
      {viewStyle === 'table' ? <FormsTable /> : <FormsCards />}
      <HasAccess service="form" permissions={['write']}>
        <RestoreModal onSubmit={restoreForm} />
        <DeleteModal onSubmit={deleteForm} />
      </HasAccess>
    </Page>
  );
};
